import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { SearchFeed } from 'screens/SearchScreen';
import styles from './SearchScreen.module.scss';
import { VerticalNavigation } from 'components';
import queryString from 'query-string';

export const SearchScreen = () => {
  const [searchString, setSearchString] = useState('');
  const params = queryString.parse(window.location.href.split('qs')[1]).term as string;

  useEffect(() => {
    setSearchString(params);
  }, [params]);

  return (
    <>
      <VerticalNavigation />
      <div className={styles.content}>
        <div className={classnames(styles.contentBin, styles.layoutMain)}>
          <div className={styles.MainColumn}>
            <div className={styles.FeedContainer}>
              {searchString && <SearchFeed searchString={searchString as string} />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
